import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material"

import { AiFillLock, AiFillUnlock, AiOutlineMail } from "react-icons/ai"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import { MdVisibility, MdVisibilityOff } from "react-icons/md"
import { Link, useNavigate } from "react-router-dom"
import { yupResolver } from "@hookform/resolvers/yup"
import mommylogo from "../../images/login-logo.png"
import baby1 from "../../images/baby1.png"
import baby3 from "../../images/babby3.png"
import baby2 from "../../images/baby3.png"
import baby4 from "../../images/babby4.png"
import googleLogo from "../../images/google-logo.png"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  useLoginMutation,
  useSignupWithGoogleMutation,
} from "../../features/Auth/authApi"
import CircularProgress from "@mui/material/CircularProgress"
import * as Style from "./style"
import { toast } from "react-toastify"
import { token, updateToken, userInfo } from "../../features/Auth/authSlice"
import { _setTicket } from "../../features/ChatAuth/chatSlice"
import { selectPendingService } from "../../features/PostCreat/postcreateSlice"

interface loginUser {
  email: string
  password: string
}
interface loginProps {}

const Login = ({}: loginProps) => {
  const [handleGoogleLogin, { isLoading: googleLoading }] =
    useSignupWithGoogleMutation()
  const [showPassword, setShowPassword] = React.useState(false)

  const dispatch = useAppDispatch()
  const pendingService = useAppSelector(selectPendingService)

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
  }
  const navigate = useNavigate()
  const [userLogin, { data, isError, error, isLoading, isSuccess }] =
    useLoginMutation()
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const schemaResolver = yupResolver(
    yup.object().shape({
      email: yup
        .string()
        .required("Please enter an email")
        .test("valid-email", "Please enter a valid email", (value) =>
          emailRegex.test(value),
        ),
      password: yup.string().required("Please fill in a password"),
    }),
  )

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<loginUser>({
    resolver: schemaResolver,
  })

  const onSubmit = async (values: any) => {
    const payload = {
      email: values.email,
      password: values.password,
    }

    try {
      const res: any = await userLogin(payload)

      if (res?.data?.message == "Login success") {
        toast.success("Login success", { autoClose: 1000 })
        dispatch(token(res?.data?.token))
        dispatch(userInfo(res?.data?.user))
        reset({ email: "", password: "" })
        // If the user arrived from a landing-page "Book Now", send them straight
        // to service selection so the chosen service can be pre-selected.
        if (pendingService) {
          navigate("/dashboard/service-selection")
        }
      } else {
        if (res?.error?.status == 400) {
          toast.error(res?.error?.data?.message, { autoClose: 1000 })
        } else if (res?.data?.status == 200) {
          toast.error(res?.data?.message, { autoClose: 1000 })
        } else {
          toast.error(res?.error?.data?.message, { autoClose: 1000 })
        }
      }
    } catch (error) {
      console.error("Error logging in:", error)
    }
  }

  return (
    <>
      <Grid container>
        <Grid
          item
          lg={7}
          className="d-none d-lg-block"
          display="flex"
          alignItems="center"
        >
          <Box className="box-wrapper">
            <Typography
              sx={{
                textAlign: "center",
                color: " #858585",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Welcome To
            </Typography>
            <Typography textAlign="center">
              <img src={mommylogo} width="300" height="auto" />
            </Typography>
            <Box
              className="Imgbox"
              display="flex"
              justifyContent="center"
              flexWrap="wrap"
              gap={2}
            >
              <Box>
                <img src={baby1} />
              </Box>
              <Box mt={5}>
                <img src={baby2} />
              </Box>

              <Box>
                <img src={baby3} />
              </Box>

              <Box mt={5}>
                <img src={baby4} />
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item lg={5}>
          <Box className="Loginform">
            <Typography
              variant="h4"
              mt={5}
              fontFamily="Montserrat"
              fontSize={22}
              fontWeight="600"
              color="pink.main"
              textAlign="center"
            >
              Login To Your Account
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box>
                <FormControl  sx={{
                  mt: 2,
                }} variant="outlined" fullWidth>
                  <InputLabel
                    htmlFor="outlined-adornment-password"
                    className=" rounded"
                  >
                    {" "}
                    Email
                  </InputLabel>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        type="email"
                        label="Email"
                        id="outlined-adornment-password"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <AiOutlineMail />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                  <p className="text-danger">{errors.email?.message}</p>
                </FormControl>
               
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-adornment-password">
                    Password
                  </InputLabel>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        id="outlined-adornment-password"
                        type={showPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <MdVisibility />
                              ) : (
                                <MdVisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                      />
                    )}
                  />
                  <p className="text-danger">{errors.password?.message}</p>
                </FormControl>
                <Box
                  mt={1}
                  className="d-flex justify-content-between align-items-center"
                >
                  <Link
                    to=""
                    className="text-login text-decoration-none"
                    onClick={() => navigate(`forget-password`)}
                  >
                    Forgot Password?
                  </Link>
                </Box>
              </Box>
              <Box>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  sx={{ mt: 9, display: "block" }}
                  fullWidth
                  className="auth-btn mx-auto"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <Typography fontSize={1}>
                      <CircularProgress
                        style={{ color: "pink", fontSize: 25 }}
                        size={25}
                      />
                    </Typography>
                  ) : (
                    "Login"
                  )}
                </Button>
              </Box>
            </form>

            <Box mb={0} mt={3} className="text-center">
              <Typography
                sx={{ color: "#7B7B7B", margin: "8px 0 0 13px" }}
                className="text-login"
              >
                Don’t Have An Account?{" "}
                <Typography
                  component="span"
                  className="text-login text-black"
                  sx={{ color: "#181818", cursor: "pointer" }}
                  onClick={() => navigate("/signup")}
                >
                  Sign Up
                </Typography>
              </Typography>
            </Box>

            <button
              onClick={() =>
                handleGoogleLogin()
                  .unwrap()
                  .then((r) => window.open(r.url, "_self"))
              }
              disabled={googleLoading}
              className="bg-transparent border-0 rounded-circle shadow-lg p-2 mx-auto mt-4"
            >
              <Box>
                <img src={googleLogo} height={35} />
              </Box>
            </button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default Login
